<!--  -->
<template>
  <div class="returnExpress">
    <common-title titleName="退货快递信息" :zIndex="1000" bcColor="#F7F8FC"></common-title>
    <div class="expressInfo">
      <van-field
        label="快递单号"
        v-model.trim="expressCard"
        type="input"
        placeholder="请输入快递单号"
        class="tmallInput"
        maxlength="50"
      ></van-field>
      <van-field
        label="快递公司"
        v-model.trim="expressName"
        type="input"
        placeholder="请输入快递公司"
        class="tmallInput"
        maxlength="20"
      ></van-field>
      <van-field
        label="快递内容"
        type="textarea"
        v-model.trim="expressText"
        placeholder="请输入快递物品信息"
        disabled
        class="tmallInput"
      ></van-field>
    </div>
    <van-button class="btn" @click="submit">确定</van-button>
    <van-popup v-model="show"
      ><div class="express-msg">
        <img v-show="success" src="@/assets/img/personalCenter/success.png" alt="" />{{ msg }}
      </div></van-popup
    >
  </div>
</template>

<script>
import { Toast } from 'vant';
import { mapState } from 'vuex';
import { reqExpressRecordDetail, reqExpressRecordEdit } from '@/api/personal';
import CommonTitle from '@/components/header/CommonTitle.vue';

export default {
  components: {
    CommonTitle,
  },
  data() {
    return {
      expressCard: '',
      expressText: '',
      expressName:'',
      show: false,
      msg: '',
      success: false,
    };
  },
  computed: {
    ...mapState(['userInfo']),
  },
  watch: {},
  methods: {
    async checkLogin() {
      await this.$root.getUserInfo();
      if (!this.$store?.state?.userInfo?.id) {
        const param = { redirect: '/returnExpress', ...this.$route.query };
        this.$router.push({ path: '/registrationLogin', query: param });
        return;
      }
      const { data, code, msg } = await reqExpressRecordDetail(this.$route.query.id);
      if (code === 0) {
        this.expressText = data?.expressItems;
        this.expressCard = data?.newExpressNum;
        this.expressName = data?.expressName
      } else {
        this.show = true;
        this.msg = msg;
      }
    },
    async submit() {
       const userReg = /^[a-zA-Z0-9]*$/;
        if (!userReg.test(this.expressCard)) {
          Toast('快递单号仅支持英文字母、阿拉伯数字');
          return;
        }
      const { code, msg } = await reqExpressRecordEdit({
        id: this.$route.query.id,
        newExpressNum: this.expressCard,
        expressName:this.expressName
      });
      if (code === 0) {
        this.msg = '操作成功';
        this.success = true;
        this.show = true;
        setTimeout(() => {
          this.$router.push({
            path: '/exam24',
            query: { code: 8 },
          });
        }, 2000);
      } else {
        this.show = true;
        this.msg = msg;
        this.success = false;
      }
    },
  },
  created() {},
  mounted() {
    this.checkLogin();
  },
};
</script>
<style lang="scss" scoped>
.returnExpress {
  width: 100%;
  min-height: 100vh;
  margin: 40px auto;
  padding-top: 110px;
  background: #F7F8FC;
  > h1 {
    padding: 30px;
    font-size: 44px;
    text-align: center;
  }
  .expressInfo {
    width: 678px;
    min-height: 217px;
    margin: 0 auto;
    padding: 29px;
    background: #fff;
    border-radius: 14px;
    ::v-deep .van-cell {
      padding-right: 0;
      padding-left: 0;
    }
    ::v-deep .van-cell::after {
      border: none;
    }

    ::v-deep .van-field__label span {
      color: #333;
      font-weight: 500;
      font-size: 13px;
    }
    ::v-deep .van-field__label {
      width: 70px;
      margin-right: 0;
    }
  }
  > .btn {
    position: fixed;
    right: 0;
    bottom: 30px;
    left: 0;
    display: block;
    width: 634px;
    height: 91px;
    margin: 0 auto;
    background: #ff7f41;
    border: none;
    border-radius: 45px;
    ::v-deep .van-button__text {
      color: #fff;
      font-weight: 500;
      font-size: 18px;
    }
  }
  .express-msg {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 453px;
    min-height: 120px;
    padding: 18px;
    color: #333;
    font-size: 15px;
    line-height: 40px;
    background: #fff;
    // text-align: left;
    img {
      width: 47px;
      height: 47px;
      margin-right: 10px;
    }
  }
  ::v-deep .van-popup {
    border-radius: 7px;
  }
}
</style>
